
import React, { Component } from 'react';
import { Markdown } from 'grommet';

class MarkdownContent extends Component {

    constructor(props) {
        super(props);
        this.state = {html: ''};
    }

    componentDidMount() {
        fetch(this.props.url)
            .then((response) => response.text())
            .then((text) => {
                this.setState({html: text});
            });
    }

    render() {
        return (
            <Markdown>{this.state.html}</Markdown>
        )
    }
}

export default MarkdownContent;
